import React from 'react';
import {Box, Typography} from '@mui/material';
import './EmptyState.scss';

interface EmptyStateProps {
  message: string;
  icon?: React.ReactNode;
  children?: React.ReactNode;
  containerHeight?: number;
  containerClassName?: string;
  messageClassName?: string;
  iconClassName?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  message = '',
  icon,
  children,
  containerHeight,
  containerClassName = '',
  messageClassName = '',
  iconClassName = '',
}) => {
  const containerStyle = containerHeight
    ? {height: `${containerHeight}rem`}
    : undefined;

  return (
    <Box
      className={`empty-state-container ${containerClassName}`}
      style={containerStyle}
      data-testid="empty-state"
    >
      {children || (
        <>
          {icon && <Box className={iconClassName}>{icon}</Box>}
          <Typography
            className={`${messageClassName} typo-text headline1_size arr-empty-state-label`}
            data-testid={`empty-state-message`}
          >
            {message}
          </Typography>
        </>
      )}
    </Box>
  );
};

export default EmptyState;
